export const CLEVERTAP_EVENTS = {
  EVENT_SIGN_UP: 'EVENT_SIGN_UP',
  EVENT_LOGIN: 'EVENT_LOGIN',
  EVENT_CHANGE_NUMBER: 'EVENT_CHANGE_NUMBER',
  EVENT_RESEND_OTP: 'EVENT_RESEND_OTP',
  EVENT_LANGUAGE_BUTTON_TAP: 'EVENT_LANGUAGE_BUTTON_TAP',
  EVENT_AUTH_ERROR_TOAST: 'EVENT_AUTH_ERROR_TOAST',
  EVENT_PHONE_PROCEED: 'EVENT_PHONE_PROCEED',
  EVENT_SCREEN_VIEW_SIGN_UP: 'EVENT_SCREEN_VIEW_SIGN_UP',
  EVENT_PHONE_INPUT: 'EVENT_PHONE_INPUT',
  EVENT_OTP_INPUT: 'EVENT_OTP_INPUT',
  EVENT_GOOGLE_SIGN_IN: 'EVENT_GOOGLE_SIGN_IN',
  EVENT_APPLE_SIGN_IN: 'EVENT_APPLE_SIGN_IN',
  EVENT_PHONE_VERIFICATION: 'EVENT_PHONE_VERIFICATION',
  EVENT_IDFA_TRACKING_ALLOWED: 'EVENT_IDFA_TRACKING_ALLOWED',
  EVENT_IDFA_TRACKING_NOT_ALLOWED: 'EVENT_IDFA_TRACKING_NOT_ALLOWED',
  EVENT_SCREEN_VIEW_OTP: 'EVENT_SCREEN_VIEW_OTP',
  EVENT_SCREEN_VIEW_SPLASH_SCREEN: 'EVENT_SCREEN_VIEW_SPLASH_SCREEN',
  EVENT_SPLASH_VIDEO_PLAYED: 'EVENT_SPLASH_VIDEO_PLAYED',
  EVENT_DEVICE_ID_PICKED_FROM_ASYNC_STORAGE: 'EVENT_DEVICE_ID_PICKED_FROM_ASYNC_STORAGE',
  PROFILE_PUSH: 'PROFILE_PUSH',
  EVENT_LANGUAGE_CHANGE: 'EVENT_LANGUAGE_CHANGE',
  EVENT_GAMEALERTS_TOGGLE: 'EVENT_GAMEALERTS_TOGGLE',
  EVENT_PROFILE_WALLET_BALANCE: 'EVENT_PROFILE_WALLET_BALANCE',
  EVENT_PROFILE_KYC: 'EVENT_PROFILE_KYC',
  EVENT_GAME_MANAGEMENT: 'EVENT_GAME_MANAGEMENT',
  EVENT_CLICK_HELP_DESK: 'EVENT_CLICK_HELP_DESK',
  EVENT_CLICK_ABOUT: 'EVENT_CLICK_ABOUT',
  EVENT_REFERRAL_SCREEN_LOAD: 'EVENT_REFERRAL_SCREEN_LOAD',
  EVENT_SIGNUP_REFERRAL_CONTINUE: 'EVENT_SIGNUP_REFERRAL_CONTINUE',
  EVENT_LOGOUT: 'EVENT_LOGOUT_NEW',
  EVENT_SCREEN_VIEW_ADD_MONEY: 'EVENT_SCREEN_VIEW_ADD_MONEY',
  EVENT_ENTER_AMOUNT: 'EVENT_ENTER_AMOUNT',
  EVENT_CLICK_ADD_MONEY: 'EVENT_CLICK_ADD_MONEY',
  EVENT_CLICK_COUPON_DETAILS: 'EVENT_CLICK_COUPON_DETAILS',
  EVENT_CLICK_APPLY_COUPON: 'EVENT_CLICK_APPLY_COUPON',
  EVENT_CLICK_PLAY_NOW_RULES: 'EVENT_CLICK_PLAY_NOW_RULES ',
  EVENT_SCREEN_VIEW_HOME: 'EVENT_SCREEN_VIEW_HOME ',
  Event_screen_view_game_management: 'Event_screen_view_game_management',
  EVENT_APP_ONBOARDING_COMPLETE: 'EVENT_APP_ONBOARDING_COMPLETE',
  EVENT_RULES_SCROLL: 'EVENT_RULES_SCROLL',
  EVENT_CLICK_NOTIFICATION: 'EVENT_CLICK_NOTIFICATION',
  EVENT_CLICK_WALLET: 'EVENT_CLICK_WALLET',
  EVENT_PLUS_ICON: 'EVENT_PLUS_ICON',
  EVENT_SEE_PAST_TICKETS: 'EVENT_SEE_PAST_TICKETS',
  EVENT_CLICK_FAQ: 'EVENT_CLICK_FAQ',
  EVENT_VIEW_HELPDESK_CONTENT: 'EVENT_VIEW_HELPDESK_CONTENT',
  EVENT_CREATE_TICKET: 'EVENT_CREATE_TICKET',
  EVENT_VIEW_TICKET_CREATED: 'EVENT_VIEW_TICKET_CREATED',
  EVENT_FILTER_APPLIED: 'EVENT_FILTER_APPLIED',
  EVENT_CLICK_TRANSACTION_SUPPORT: 'EVENT_CLICK_TRANSACTION_SUPPORT',
  EVENT_ADD_MONEY_INIT: 'EVENT_ADD_MONEY_INIT',
  EVENT_ADD_MONEY_SUCCESS: 'EVENT_ADD_MONEY_SUCCESS',
  EVENT_ADD_MONEY_FAILURE: 'EVENT_ADD_MONEY_FAILURE',
  EVENT_ADD_MONEY_PENDING: 'EVENT_ADD_MONEY_PENDING',
  EVENT_WITHDRAW_REQ: 'EVENT_WITHDRAW_REQ',
  EVENT_CLICK_CCDC_MENU: 'EVENT_CLICK_CCDC_MENU',
  EVENT_CLICK_PAYMENT_WALLET: 'EVENT_CLICK_PAYMENT_WALLET',
  EVENT_CLICK_QUICKPAY: 'EVENT_CLICK_QUICKPAY',
  EVENT_CLICK_NETBANKING: 'EVENT_CLICK_NETBANKING',
  EVENT_CLICK_UPI: 'EVENT_CLICK_UPI',
  EVENT_CLICK_CARD: 'EVENT_CLICK_CARD',
  EVENT_CLICK_CCDC_PROCEED: 'EVENT_CLICK_CCDC_PROCEED',
  EVENT_CLICK_CCDC_ADDNEW: 'EVENT_CLICK_CCDC_ADDNEW',
  EVENT_EDIT_AVATAR: 'EVENT_EDIT_AVATAR',
  EVENT_CLICK_PROFILE: 'EVENT_CLICK_PROFILE',
  EVENT_REGISTER_TOURNAMENT: 'EVENT_REGISTER_TOURNAMENT',
  EVENT_CLICK_SHARE_REFERRAL: 'EVENT_CLICK_SHARE_REFERRAL',
  EVENT_LEAVE_TABLE: 'EVENT_LEAVE_TABLE',
  EVENT_ARRIVED_RESULT_PO: 'EVENT_ARRIVED_RESULT_PO',
  EVENT_ARRIVED_RESULT_PWF: 'EVENT_ARRIVED_RESULT_PWF',
  EVENT_MUSIC_OFF: 'EVENT_MUSIC_OFF',
  EVENT_SOUND_OFF: 'EVENT_SOUND_OFF',
  EVENT_WINNER_DECLARED_IOS: 'EVENT_WINNER_DECLARED_IOS',
  EVENT_CLICK_GOTO_LOBBY_RESULT_PO: 'EVENT_CLICK_GOTO_LOBBY_RESULT_PO',
  EVENT_CLICK_HOME_RESULT_PO: 'EVENT_CLICK_HOME_RESULT_PO',
  EVENT_GAME_STARTED: 'EVENT_GAME_STARTED',
  EVENT_COUNTDOWN_SCREEN: 'EVENT_COUNTDOWN_SCREEN',
  EVENT_SCREEN_VIEW_MTT_LANDING: 'EVENT_SCREEN_VIEW_MTT_LANDING',
  EVENT_REGISTER_MTT: 'EVENT_REGISTER_MTT',
  EVENT_GENERIC_NUDGE_POPUP: 'EVENT_GENERIC_NUDGE_POPUP',
  EVENT_GENERIC_NUDGE_DISMISS: 'EVENT_GENERIC_NUDGE_DISMISS',
  EVENT_CLICK_DOC: 'EVENT_CLICK_DOC',
  EVENT_CLICK_USER_CONSENT: 'EVENT_CLICK_USER_CONSENT',
  EVENT_CLICK_GENERATE_OTP: 'EVENT_CLICK_GENERATE_OTP',
  EVENT_CLICK_SUBMIT_OTP: 'EVENT_CLICK_SUBMIT_OTP',
  EVENT_CLICK_RESEND_OTP: 'EVENT_CLICK_RESEND_OTP',
  EVENT_TNC_PP_POPUP: 'EVENT_TNC_PP_POPUP',
  EVENT_TNC_PP_CONSENT: 'EVENT_TNC_PP_CONSENT',
  EVENT_GENERIC_NUDGE_POSITIVE_CTA: 'EVENT_GENERIC_NUDGE_POSITIVE_CTA',
  EVENT_GENERIC_NUDGE_NEGATIVE_CTA: 'EVENT_GENERIC_NUDGE_NEGATIVE_CTA',
  Event_Click_TDS_info: 'Event_Click_TDS_info',
  Event_Screen_view_TDS_Details: 'Event_Screen_view_TDS_Details',
  Event_Click_TDS_FAQ: 'Event_Click_TDS_FAQ',
  EVENT_CLICK_CASHBACK: 'EVENT_CLICK_CASHBACK',
  EVENT_CLICK_RETRY_CASHBACK_DETAIL: 'EVENT_CLICK_RETRY_CASHBACK_DETAIL',
  EVENT_API_FAILURE: 'EVENT_API_FAILURE',
  EVENT_CSAT_SUBMIT: 'Event_CSAT_submit',
  EVENT_CSAT_APPEARS: 'Event_CSAT_Appears',
  EVENT_CLICK_PO: 'EVENT_CLICK_PO',
  EVENT_SCREEN_VIEW_SIGN_IN: 'EVENT_SCREEN_VIEW_SIGN_IN',
  EVENT_SCREEN_VIEW_ABOUT: 'EVENT_SCREEN_VIEW_ABOUT',
  EVENT_SCREEN_VIEW_KYC: 'EVENT_SCREEN_VIEW_KYC',
  EVENT_TOOLTIP_VIEW: 'EVENT_TOOLTIP_VIEW',
  EVENT_REFERRAL_CODE_SKIP: 'EVENT_REFERRAL_CODE_SKIP',
  EVENT_GAME_MUSIC_TOGGLE: 'EVENT_GAME_MUSIC_TOGGLE',
  EVENT_GAME_SOUND_TOGGLE: 'EVENT_GAME_SOUND_TOGGLE',
  EVENT_GAME_VIBRATION_TOGGLE: 'EVENT_GAME_VIBRATION_TOGGLE',
  READ_AUTO_REFERRAL_CODE: 'READ_AUTO_REFERRAL_CODE',

  /** Profile Screen */
  EVENT_SEE_PROFILE: 'EVENT_SEE_PROFILE',
  EVENT_QUICK_VIEW_PROFILE: 'EVENT_QUICK_VIEW_PROFILE',
  EVENT_PROFILE_PIC_UPDATE: 'EVENT_PROFILE_PIC_UPDATE',
  EVENT_PROFILE_UPDATE: 'EVENT_PROFILE_UPDATE',
  EVENT_SCREEN_VIEW_GAME_HISTORY: 'EVENT_SCREEN_VIEW_GAME_HISTORY',
  EVENT_CLICK_LIKE_MEME: 'EVENT_CLICK_LIKE_MEME',
  EVENT_CLICK_SHARE_MEME: 'EVENT_CLICK_SHARE_MEME',
  EVENT_SCREEN_VIEW_COMMUNITY: 'EVENT_SCREEN_VIEW_COMMUNITY',
  EVENT_SCREEN_VIEW_LEADERBOARD_DETAILS: 'EVENT_SCREEN_VIEW_LEADERBOARD_DETAILS',
  EVENT_SCREEN_VIEW_FOLLOWING: 'EVENT_SCREEN_VIEW_FOLLOWING',
  EVENT_SCREEN_VIEW_FOLLOWERS: 'EVENT_SCREEN_VIEW_FOLLOWERS',
  EVENT_PROFILE_FOLLOW: 'EVENT_PROFILE_FOLLOW',
  EVENT_PROFILE_UNFOLLOW: 'EVENT_PROFILE_UNFOLLOW',
  EVENT_PROFILE_REMOVE: 'EVENT_PROFILE_REMOVE',
  EVENT_OPEN_PUSH_NOTIFICATION: 'EVENT_OPEN_PUSH_NOTIFICATION',
  EVENT_CLICK_INAPP_NOTIFICATION: 'EVENT_CLICK_INAPP_NOTIFICATION',
  EVENT_VIEW_MORE_OPTIONS: 'EVENT_VIEW_MORE_OPTIONS',

  /** Wallet Screen */
  EVENT_CLICK_ADD_CASH: 'EVENT_CLICK_ADD_CASH',
  EVENT_CLICK_WITHDRAW: 'EVENT_CLICK_WITHDRAW',
  EVENT_CLICK_BONUS_DETAILS: 'EVENT_CLICK_BONUS_DETAILS',
  EVENT_CLICK_TRANSACTION_HISTORY: 'EVENT_CLICK_TRANSACTION_HISTORY',
  EVENT_CLICK_TDS_DETAILS: 'EVENT_CLICK_TDS_DETAILS',
  EVENT_CLICK_BACK_WALLET: 'EVENT_CLICK_BACK_WALLET',
  EVENT_SCREEN_VIEW_TRANSACTION_HISTORY: 'EVENT_SCREEN_VIEW_TRANSACTION_HISTORY',
  EVENT_SCREEN_VIEW_TDS_CERTIFICATE: 'EVENT_SCREEN_VIEW_TDS_CERTIFICATE',

  /** AddCash Screen */
  EVENT_CLICK_BACK_ADD_MONEY: 'EVENT_CLICK_BACK_ADD_MONEY',
  EVENT_CLICK_APPLY: 'EVENT_CLICK_APPLY',
  EVENT_CLICK_BS_COUPON_APPLY: 'EVENT_CLICK_BS_COUPON_APPLY',
  EVENT_CLOSE_ADD_MONEY: 'EVENT_CLOSE_ADD_MONEY',
  EVENT_CONFIRM_REMOVE_REFERRAL: 'EVENT_CONFIRM_REMOVE_REFERRAL',
  EVENT_CANCEL_REMOVE_REFERRAL: 'EVENT_CANCEL_REMOVE_REFERRAL',
  EVENT_CLICK_REMOVE_REFERRAL: 'EVENT_CLICK_REMOVE_REFERRAL',
  EVENT_CLICK_SUCCESS_PARTNER_COUPON: 'EVENT_CLICK_SUCCESS_PARTNER_COUPON',
  EVENT_CLICK_FAILURE_PARTNER_COUPON: 'EVENT_CLICK_FAILURE_PARTNER_COUPON',
  EVENT_REFERRAL: 'EVENT_REFERRAL',
  EVENT_REFERRAL_FAILURE: 'EVENT_REFERRAL_FAILURE',

  /** Banner */
  EVENT_CLICK_BANNER: 'EVENT_CLICK_BANNER',

  /** Withdrawal */
  EVENT_CLICK_BACK_WITHDRAWALS: 'EVENT_CLICK_BACK_WITHDRAWALS',
  EVENT_CLICK_KNOW_MORE_WITHDRAWALS: 'EVENT_CLICK_KNOW_MORE_WITHDRAWALS',
  EVENT_CLICK_TDS_CALCULATION_WORK: 'EVENT_CLICK_TDS_CALCULATION_WORK',
  EVENT_SCREEN_VIEW_WITHDRAWALS: 'EVENT_SCREEN_VIEW_WITHDRAWALS',
  EVENT_CLICK_WITHDRAWAL_MODES: 'EVENT_CLICK_WITHDRAWAL_MODES', // type: ['UPI', 'Bank account']
  EVENT_CLICK_WITHDRAWAL_LINK_UPI: 'EVENT_CLICK_WITHDRAWAL_LINK_UPI',
  EVENT_CLICK_LINK_UPI_PROCEED: 'EVENT_CLICK_LINK_UPI_PROCEED',
  EVENT_CLICK_WITHDRAWAL_ADD_BANK: 'EVENT_CLICK_WITHDRAWAL_ADD_BANK',
  EVENT_CLICK_ADD_BANK_PROCEED: 'EVENT_CLICK_ADD_BANK_PROCEED',
  EVENT_KYC_NUDGE_POPUP: 'EVENT_KYC_NUDGE_POPUP',
  EVENT_KYC_NUDGE_ACCEPT: 'EVENT_KYC_NUDGE_ACCEPT',
  EVENT_KYC_NUDGE_DISMISS: 'EVENT_KYC_NUDGE_DISMISS',
  EVENT_WITHDRAW_INFO_SCREEN: 'EVENT_WITHDRAW_INFO_SCREEN',
  EVENT_WITHDRAW_SCREEN_CTA_CLICKED: 'EVENT_WITHDRAW_SCREEN_CTA_CLICKED',
  EVENT_CHANGE_WITHDRAWAL_METHOD_CLICKED: 'EVENT_CHANGE_WITHDRAWAL_METHOD_CLICKED',
  EVENT_WITHDRAWAL_CONFIRM_BS_CTA_CLICKED: 'EVENT_WITHDRAWAL_CONFIRM_BS_CTA_CLICKED',
  EVENT_WITHDRAWAL_CONFIRM_BS_VIEW: 'EVENT_WITHDRAWAL_CONFIRM_BS_VIEW',
  EVENT_CONFIRM_BOTTOMSHEET_CLOSED: 'EVENT_CONFIRM_BOTTOMSHEET_CLOSED',
  EVENT_WITHDRAWAL_STATUS_SCREEN_VIEW: 'EVENT_WITHDRAWAL_STATUS_SCREEN_VIEW',
  EVENT_PROMOTIONAL_CTA_CLICKED: 'EVENT_PROMOTIONAL_CTA_CLICKED',
  EVENT_STATUS_SCREEN_CTA_CLICKED: 'EVENT_STATUS_SCREEN_CTA_CLICKED',
  EVENT_WITHDRAWAL_MODE_BS_VIEW: 'EVENT_WITHDRAWAL_MODE_BS_VIEW',
  EVENT_LINK_UPI_ID_CLICKED: 'EVENT_LINK_UPI_ID_CLICKED',
  EVENT_ADD_BANK_CLICKED: 'EVENT_ADD_BANK_CLICKED',
  EVENT_WITHDRAWAL_MODE_CTA_CLICKED: 'EVENT_WITHDRAWAL_MODE_CTA_CLICKED',
  EVENT_WITHDRAWAL_MODE_BS_CLOSED: 'EVENT_WITHDRAWAL_MODE_BS_CLOSED',
  EVENT_ENTER_UPI_CTA_CLICKED: 'EVENT_ENTER_UPI_CTA_CLICKED',
  EVENT_UPI_ADDED_SUCCESSFUL: 'EVENT_UPI_ADDED_SUCCESSFUL',
  EVENT_UPI_ADDED_FAILED: 'EVENT_UPI_ADDED_FAILED',
  EVENT_ENTER_UPI_BS_CLOSED: 'EVENT_ENTER_UPI_BS_CLOSED',
  EVENT_UPI_BOTTOMSHEET_VIEW: 'EVENT_UPI_BOTTOMSHEET_VIEW',
  EVENT_ADD_BANK_ACCOUNT_CTA_CLICKED: 'EVENT_ADD_BANK_ACCOUNT_CTA_CLICKED',
  EVENT_BANK_ACCOUNT_ADDED_SUCCESSFUL: 'EVENT_BANK_ACCOUNT_ADDED_SUCCESSFUL',
  EVENT_BANK_ACCOUNT_ADDED_FAILED: 'EVENT_BANK_ACCOUNT_ADDED_FAILED',
  EVENT_BACK_ON_ADD_BANK_ACCOUNT: 'EVENT_BACK_ON_ADD_BANK_ACCOUNT',
  EVENT_ADD_BANK_ACCOUNT_VIEW: 'EVENT_ADD_BANK_ACCOUNT_VIEW',

  //App rating pop up
  APP_RATING_POPUP: 'APP_RATING_POPUP',
  //NEW ADD Cash
  EVENT_DEPOSIT_PROCEED_BS_CTA_CLICKED: 'EVENT_DEPOSIT_PROCEED_BS_CTA_CLICKED',
  EVENT_DEPOSIT_PROCEED_BS_VIEW: 'EVENT_DEPOSIT_PROCEED_BS_VIEW',
  EVENT_DEPOSIT_PROCEED_BS_CTA_CLOSED: 'EVENT_DEPOSIT_PROCEED_BS_CTA_CLOSED',
  EVENT_DEPOSIT_PROCEED_BS_SECTION_CLICKED: 'EVENT_DEPOSIT_PROCEED_BS_SECTION_CLICKED',
  EVENT_DEPOSIT_PROCEED_BS_SUBSECTION_CLICKED: 'EVENT_DEPOSIT_PROCEED_BS_SUBSECTION_CLICKED',
  EVENT_DEPOSIT_PROCEED_BS_LINK_CLICKED: 'EVENT_DEPOSIT_PROCEED_BS_LINK_CLICKED',

  // Refer and earn Screen
  EVENT_CLICK_REFER_REWARD_INFO: 'EVENT_CLICK_REFER_REWARD_INFO',
  EVENT_SCREEN_VIEW_REFER_AND_EARN: 'EVENT_SCREEN_VIEW_REFER_AND_EARN',

  //RG
  EVENT_RG_LANDING: 'EVENT_RG_LANDING',
  EVENT_LOSS_MANAGEMENT_LANDING: 'EVENT_LOSS_MANAGEMENT_LANDING',
  EVENT_INITIATING_QUIZ: 'EVENT_INITIATING_QUIZ',
  EVENT_QUIZ_START: 'EVENT_QUIZ_START',
  EVENT_QUIZ_FINISH: 'EVENT_QUIZ_FINISH',
  EVENT_QUIZ_QUIT: 'EVENT_QUIZ_QUIT',
  EVENT_VIEW_FAQ: 'EVENT_VIEW_FAQ',
  EVENT_VIEW_LM_BOTTOM_SHEET: 'EVENT_VIEW_LM_BOTTOM_SHEET',
  EVENT_SET_LOSS_AMOUNT: 'EVENT_SET_LOSS_AMOUNT',
  EVENT_SET_TIME_PERIOD: 'EVENT_SET_TIME_PERIOD',
  EVENT_SET_GAME_LOCK_PERIOD: 'EVENT_SET_GAME_LOCK_PERIOD',
  EVENT_LOSS_LIMITS_CONFIRM: 'EVENT_LOSS_LIMITS_CONFIRM',
  EVENT_EDIT_LOSS_LIMITS: 'EVENT_EDIT_LOSS_LIMITS',
  EVENT_REMOVE_LOSS_LIMITS: 'EVENT_REMOVE_LOSS_LIMITS',

  // Collusion
  EVENT_REPORT_COLLUSION: 'EVENT_REPORT_COLLUSION',

  // PAW
  EVENT_CLICK_PAW_V2_ANSWER: "EVENT_CLICK_ANSWER",
  EVENT_CLICK_PAW_V2_RESULT_OUT: "EVENT_CLICK_RESULT_OUT",
  EVENT_CLICK_PAW_V2_NEXT_QUESTION: "EVENT_CLICK_NEXT_QUESTION",
  EVENT_CLICK_PAW_V2_COLLECT_REWARD: "EVENT_CLICK_COLLECT_REWARD",
  EVENT_CLICK_PAW_V2_REWARD_HISTORY: "EVENT_CLICK_REWARD_HISTORY",
  EVENT_CLICK_PAW_V2_CLAIMED_REWARD: "EVENT_CLICK_CLAIMED_REWARD",

  // Mentioned in android with PAW events but not part of PAW, seems to be used with referral
  EVENT_STATIC_BONUS_ANIMATION: "EVENT_STATIC_BONUS_ANIMATION",
  EVENT_DYNAMIC_BONUS_ANIMATION: "EVENT_DYNAMIC_BONUS_ANIMATION",

  //Home v4
  EVENT_CLICK_NEW_ARRIVAL_CTA: "EVENT_CLICK_NEW_ARRIVAL_CTA",

  //Helpdesk yellow AI events
  EVENT_HELPDESK_GR: 'EVENT_HELPDESK_GR',
  EVENT_HELPDESK_DW: "EVENT_HELPDESK_DW",
  EVENT_HELPDESK_TDS: "EVENT_HELPDESK_TDS",
  EVENT_HELPDESK_KYC: "EVENT_HELPDESK_KYC",
  EVENT_HELPDESK_ACC: "EVENT_HELPDESK_ACC",
  EVENT_HELPDESK_DZA: "EVENT_HELPDESK_DZA",

  // VIP Screens
  EVENT_CLICK_VIP_ONBOARD: "EVENT_CLICK_VIP_ONBOARD",
  EVENT_VIP_SCREEN: "EVENT_VIP_SCREEN",
  EVENT_CLICK_VIP_WELCOME_REWARD: "EVENT_CLICK_VIP_WELCOME_REWARD",
  EVENT_VIP_DICE_SCREEN: "EVENT_VIP_DICE_SCREEN",
  EVENT_CLICK_VIP_DICE_PREVIEW: "EVENT_CLICK_VIP_DICE_PREVIEW",
  EVENT_CLICK_VIP_CHANGE_DICE: "EVENT_CLICK_VIP_CHANGE_DICE",
  EVENT_CLICK_VIP_WEEKLY_CHALLENGE: "EVENT_CLICK_VIP_WEEKLY_CHALLENGE",
  EVENT_CLICK_VIP_REVEAL_REWARD: "EVENT_CLICK_VIP_REVEAL_REWARD",
  EVENT_CLICK_VIP_BENEFITS: "EVENT_CLICK_VIP_BENEFITS ",
  EVENT_CLICK_VIP_REWARD_HISTORY: "EVENT_CLICK_VIP_REWARD_HISTORY",
  EVENT_CLICK_VIP_WEEKLY_REWARD: "EVENT_CLICK_VIP_WEEKLY_REWARD",

  // Ludo Academy
  EVENT_CLICK_LUDOTV: "EVENT_CLICK_LUDOTV",
  EVENT_CLICK_LUDOTVBANNER: "EVENT_CLICK_LUDOTVBANNER",

  //Quick Actions
  APP_ICON_LONG_PRESS: "APP_ICON_LONG_PRESS",

  // DGP
  EVENT_SCREENVIEW_DIRECT_GAMEPLAY: "EVENT_SCREENVIEW_DIRECT_GAMEPLAY",
  EVENT_REGISTER_TOURNAMENT_DIRECT_GAMEPLAY: "EVENT_REGISTER_TOURNAMENT_DIRECT_GAMEPLAY",
  EVENT_SCREEN_VIEW_GAME_ONBOARDING_DIRECT_GAMEPLAY: "EVENT_SCREEN_VIEW_GAME_ONBOARDING_DIRECT_GAMEPLAY",
  EVENT_CLOSE_SCREEN_DIRECT_GAMEPLAY: "EVENT_CLOSE_SCREEN_DIRECT_GAMEPLAY",
  EVENT_BACK_DIRECT_GAMEPLAY: "EVENT_BACK_DIRECT_GAMEPLAY"
}

export const CLEVERTAP_EVENTS_SET = new Set(Object.values(CLEVERTAP_EVENTS))
